const TOAST_GAP = 8;

export function toastBottomAbove(dockTop: number, viewportHeight: number): number {
  return Math.max(viewportHeight - dockTop + TOAST_GAP, TOAST_GAP);
}

export function followDock(toastEl: HTMLElement | undefined): () => void {
  const dock = document.querySelector('.page-current .ai-dock--floating');
  if (!toastEl || !dock) return () => {};
  const place = () => {
    const bottom = toastBottomAbove(dock.getBoundingClientRect().top, window.innerHeight);
    toastEl.style.bottom = `${bottom}px`;
    toastEl.style.marginBottom = '0';
  };
  place();
  const observer = new ResizeObserver(place);
  observer.observe(dock);
  return () => observer.disconnect();
}
